export const CheersGlasses = ({ className = "w-40 h-24" }) => (
  <svg
    viewBox="0 0 200 110"
    fill="none"
    className={className}
    data-testid="hero-cheers-icon-motif"
    aria-label="Clinking champagne glasses"
  >
    {/* sparkles at clink point */}
    <g stroke="#F5C77E" strokeWidth="2" strokeLinecap="round">
      <path className="sparkle-pop" d="M100 8 L100 20 M94 14 L106 14" />
      <path className="sparkle-pop s2" d="M84 22 L90 30 M90 22 L84 30" />
      <path className="sparkle-pop s3" d="M116 22 L110 30 M110 22 L116 30" />
    </g>

    {/* left flute */}
    <g className="glass-left">
      <path
        d="M58 30 L86 30 L82 62 Q72 70 62 62 Z"
        fill="rgba(224,192,117,0.12)"
        stroke="#E0C075"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path d="M62 50 Q72 56 82 50 L80 60 Q72 66 64 60 Z" fill="rgba(245,199,126,0.55)" />
      <circle cx="70" cy="44" r="1.6" fill="#F5C77E" opacity="0.8" />
      <circle cx="76" cy="40" r="1.2" fill="#F5C77E" opacity="0.6" />
      <path d="M72 68 L72 90" stroke="#E0C075" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M58 90 L86 90" stroke="#E0C075" strokeWidth="2.5" strokeLinecap="round" />
    </g>

    {/* right flute */}
    <g className="glass-right">
      <path
        d="M114 30 L142 30 L138 62 Q128 70 118 62 Z"
        fill="rgba(224,192,117,0.12)"
        stroke="#E0C075"
        strokeWidth="2.5"
        strokeLinejoin="round"
      />
      <path d="M118 50 Q128 56 138 50 L136 60 Q128 66 120 60 Z" fill="rgba(245,199,126,0.55)" />
      <circle cx="126" cy="44" r="1.6" fill="#F5C77E" opacity="0.8" />
      <circle cx="132" cy="40" r="1.2" fill="#F5C77E" opacity="0.6" />
      <path d="M128 68 L128 90" stroke="#E0C075" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M114 90 L142 90" stroke="#E0C075" strokeWidth="2.5" strokeLinecap="round" />
    </g>
  </svg>
);
